import { css as c, LitElement as u, html as p } from "lit";
import { property as i, customElement as g } from "lit/decorators.js";
import { classMap as k } from "lit/directives/class-map.js";
import { styleMap as b } from "lit/directives/style-map.js";
import { b as h } from "./styles-scZ6dVz-.js";
var y = Object.defineProperty, f = Object.getOwnPropertyDescriptor, n = (a, e, l, o) => {
  for (var r = o > 1 ? void 0 : o ? f(e, l) : e, d = a.length - 1, m; d >= 0; d--)
    (m = a[d]) && (r = (o ? m(e, l, r) : m(r)) || r);
  return o && r && y(e, l, r), r;
};
let t = class extends u {
  constructor() {
    super(...arguments), this.shape = "rectangle", this.noAnimation = !1;
  }
  render() {
    const a = {
      skeleton: !0,
      [this.shape]: !0,
      "no-animation": this.noAnimation
    }, e = {
      width: this.width,
      height: this.height
    };
    return p`
      <div
        part="skeleton"
        class=${k(a)}
        style=${b(e)}
        aria-hidden="true"
      ></div>
    `;
  }
};
t.styles = [
  h,
  c`
      :host {
        display: block;
      }

      .skeleton {
        background-color: var(--r5-skeleton-bg, var(--r5-color-neutral-200));
        background-image: linear-gradient(
          90deg,
          transparent,
          var(--r5-skeleton-shimmer, rgba(255, 255, 255, 0.5)),
          transparent
        );
        background-size: 200% 100%;
        animation: ark-skeleton-shimmer 1.5s ease-in-out infinite;
      }

      /* Shape variants */
      .rectangle {
        border-radius: var(--r5-radius-md);
      }

      .circle {
        border-radius: 50%;
      }

      .text {
        border-radius: var(--r5-radius-default);
        height: 1em;
      }

      /* No animation option */
      .no-animation {
        animation: none;
        background-image: none;
      }

      @keyframes ark-skeleton-shimmer {
        0% {
          background-position: -200% 0;
        }
        100% {
          background-position: 200% 0;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .skeleton {
          animation: none;
          background-image: none;
        }
      }
    `
];
n([
  i({ type: String })
], t.prototype, "width", 2);
n([
  i({ type: String })
], t.prototype, "height", 2);
n([
  i({ type: String, reflect: !0 })
], t.prototype, "shape", 2);
n([
  i({ type: Boolean, attribute: "no-animation" })
], t.prototype, "noAnimation", 2);
t = n([
  g("ark-skeleton")
], t);
let s = class extends u {
  constructor() {
    super(...arguments), this.lines = 3;
  }
  render() {
    return p`
      <div part="container" class="container" aria-hidden="true">
        ${Array.from({ length: this.lines }, (a, e) => p`
          <div part="line" class="line" style="animation-delay: ${e * 0.1}s"></div>
        `)}
      </div>
    `;
  }
};
s.styles = [
  h,
  c`
      :host {
        display: block;
      }

      .container {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-2);
      }

      .line {
        background-color: var(--r5-skeleton-bg, var(--r5-color-neutral-200));
        background-image: linear-gradient(
          90deg,
          transparent,
          var(--r5-skeleton-shimmer, rgba(255, 255, 255, 0.5)),
          transparent
        );
        background-size: 200% 100%;
        animation: ark-skeleton-shimmer 1.5s ease-in-out infinite;
        border-radius: var(--r5-radius-default);
        height: 0.875rem;
      }

      .line:last-child {
        width: 60%;
      }

      @keyframes ark-skeleton-shimmer {
        0% {
          background-position: -200% 0;
        }
        100% {
          background-position: 200% 0;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .line {
          animation: none;
          background-image: none;
        }
      }
    `
];
n([
  i({ type: Number })
], s.prototype, "lines", 2);
s = n([
  g("ark-skeleton-text")
], s);
export {
  t as A,
  s as a
};
//# sourceMappingURL=ark-skeleton-D0JNIrqM.js.map
